"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  UPLOAD_BULK_RESOURCE: "@@assetBulkUpload/upload-resource",
  UPLOAD_BULK_RESOURCE_FILES: "@@assetBulkUpload/upload-resource-files",
  UPLOAD_BULK_RESOURCE_FILES_DATA: "@@assetBulkUpload/upload-resource-files-data",
  UPLOAD_BULK_RESOURCE_FILES_REFRESH: "@@assetBulkUpload/upload-resource-files-refresh",
  RESET: "@@assetBulkUpload/reset",
  RESET_DATA: "@@assetBulkUpload/reset-data",
  SUCCESS: "@@assetBulkUpload/success",
  ERROR: "@@assetBulkUpload/error"
};
exports.actionTypes = actionTypes;